<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3995_10681"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="30"
      height="30"
    >
      <rect width="30" height="30" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3995_10681)">
      <path
        d="M16.6589 18.0197V9.49259M16.6589 18.0197L22.5256 21.372C22.6877 21.4646 22.8712 21.513 23.0579 21.5123C23.2446 21.5117 23.4278 21.4621 23.5892 21.3684C23.7507 21.2747 23.8847 21.1403 23.9779 20.9785C24.0711 20.8168 24.1201 20.6334 24.1202 20.4468V7.06555C24.1201 6.87889 24.0711 6.69552 23.9779 6.53379C23.8847 6.37205 23.7507 6.23762 23.5892 6.14395C23.4278 6.05027 23.2446 6.00064 23.0579 6.00001C22.8712 5.99938 22.6877 6.04777 22.5256 6.14035L16.6589 9.49259M16.6589 18.0197H13.4613M16.6589 9.49259H10.2636C9.1328 9.49259 8.04835 9.94179 7.24877 10.7414C6.4492 11.5409 6 12.6254 6 13.7562V13.7562C6 14.8869 6.4492 15.9714 7.24877 16.771C8.04835 17.5705 9.1328 18.0197 10.2636 18.0197M10.2636 18.0197V22.8163C10.2636 23.2403 10.432 23.647 10.7319 23.9468C11.0317 24.2466 11.4384 24.4151 11.8624 24.4151C12.2865 24.4151 12.6931 24.2466 12.993 23.9468C13.2928 23.647 13.4613 23.2403 13.4613 22.8163V18.0197M10.2636 18.0197H13.4613"
        stroke="url(#paint0_linear_3995_10681)"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3995_10681"
        x1="15.0601"
        y1="6"
        x2="15.0601"
        y2="24.4151"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
<style lang="scss" scoped></style>
